module.exports = __webpack_public_path__ + "img/labmem_text_share_kr.88c08685.png";